import React, { useState } from "react";
import "../styles/NotificationManagement.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IoIosNotifications } from "react-icons/io";

const EditNotification = () => {
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());

  const handleDateTimeChange = (date) => {
    setSelectedDateTime(date);
  };

  const formatDateTime = (date) => {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes();
    const ampm = date.getHours() >= 12 ? "PM" : "AM";

    return `${day}/${month}/${year} ${hours}:${
      minutes < 10 ? "0" + minutes : minutes
    } ${ampm}`;
  };
  return (
    <div className="exerciseManagementContainer">
      <div className="exerciseManagementHeader">
        <div className="exerciseHeaderLeft">
          <IoIosNotifications
            size={30}
            color="#ff0000"
            style={{ marginRight: 10 }}
          />
          <h2>Edit Notification</h2>
        </div>
      </div>
      <div className="notificationMain" style={{ marginTop: 40 }}>
        <h2 style={{ textAlign: "left" }}>Edit Automated Notifications</h2>
        <div className="notificationInputMain">
          <div className="addUserProfileInput">
            <label>Title</label>
            <input type="text" placeholder="Enter title" />
          </div>
          <div className="addUserProfileInput" style={{ marginTop: 20 }}>
            <label>Description</label>
            <textarea
              type="text"
              placeholder="Enter Description"
              className="descNotify"
            />
          </div>
        </div>
        <h3 style={{ margin: "20px 0 20px 50px" }}>Notification Schedule:</h3>
        <div className="dateAndTimeContainer">
          <DatePicker
            selected={selectedDateTime}
            onChange={handleDateTimeChange}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={15}
            timeCaption="Time"
            dateFormat="dd/MM/yyyy h:mm aa"
            className="custom-datepicker"
          />
        </div>
        <div
          className="addUserBottomAggreementAndSaveButtonContainer"
          style={{ marginLeft: 50 }}
        >
          <button>Update</button>
        </div>
      </div>
    </div>
  );
};

export default EditNotification;
